<!-- 商品轮播图组建 -->
<template>
  <div style="position: relative;">
    <div class="detail-image">
      <div class="goods-detail-pic" id="mySwipe" :style="{width:width+ 'px'}">
        <ul :style="{width:width * currentImageList.length + 'px'}">
          <li v-for="item in currentImageList" :style="{width:width+ 'px'}" @click="bindNaviageToBrownImage()">
            <img class="J-scroll-exclude" :src="item.imageSrc+'@350w_350h'">
          </li>
        </ul>
      </div>
    </div>
    <div class="bx-pager" v-if="currentImageList.length != 1">
                            <span v-for="(index,showIndex) in currentImageList"
                                  class="bx-pager-item"
                                  @click="core(index)"
                                  v-bind:class="{active:showIndex + 1 == currentNumber }"></span>
    </div>
  </div>
</template>
<script>
  var first = true,
    mySwipe
    ;
  export default {
    props: ['imageList', 'currentColorId'],
    data() {
    return {
      currentNumber: 1,
      maxLength: 0 ,
      wWidth : 0
    }
  },
  computed: {
    //当前显示的图片组
    currentImageList: function() {

      if (!this.imageList || !this.imageList.length) return []
      var self = this,
        _currentColorId =  this.imageList[0].colorId,    //this.currentColorId ? this.currentColorId :
        _imageList = this.imageList
        ;
      return _imageList.filter(function(value) {
        return value.colorId == _currentColorId
      })
    },
    width:{
      get:function () {
        return this.wWidth ? this.wWidth : $(window).width()
      },
      set:function (value) {
        this.wWidth  = value ;
      }
    }
  },

  watch: {
    currentColorId: function(newValue, oldValue) {
      var self = this
      this.$nextTick(function(){

        self.refreshSwipe()
      })
    }
  },
  mounted() {

    var self = this ;
    this.refreshSwipe()
    $(window).resize(function () {

      self.width = $(window).width()
    });
    $('img').imagesLoaded()
      .progress(function (instance, image) {
        image.img.src = image.isLoaded ? image.img.src : WapSiteUrl + "/images/bg_loading_170x170_@2x.png";
      });
  },

    methods: {
      refreshSwipe() {
        var self = this,
          $ms = document.getElementById("mySwipe");
        if (!$ms) return;
        //设置右下角数量
        this.currentNumber = 1;
        this.maxLength = this.currentImageList.length
        mySwipe&& mySwipe.refresh()
        mySwipe = new IScroll("#mySwipe", {
          // stopPropagation:true ,
          scrollX: true,
          scrollY: false,
          momentum: false,
          snap: true,
          excludeSnapY:true,
          snapSpeed: 400,
          click: true,
          bounce: true ,
          snapCallBack:function(pageX , pageY){
            var _currentNumber = pageX +1
            self.currentNumber = _currentNumber > self.maxLength ? self.maxLength : _currentNumber
          }
        });
      } ,

    /**
     * 点击预览图片
     */
    bindNaviageToBrownImage:function(){
      var _imageList = this.currentImageList.map(function (item) {
        return item.imageSrc
      }).join(',');

      this.$emit("browseimage" , _imageList ,this.currentNumber);
      console.log(9999)
    }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/goods-slide-show/goods-slide-show.vue